import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/login/page";
import VacancySelectionPage from "../pages/vacancy-selection/page";
import HRManagerPage from "../pages/hr-manager/page";
import ChatOperatorPage from "../pages/chat-operator/page";
import MeetingPage from "../pages/meeting/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LoginPage />,
  },
  {
    path: "/vacancy",
    element: <VacancySelectionPage />,
  },
  {
    path: "/hr-manager",
    element: <HRManagerPage />,
  },
  {
    path: "/chat-operator",
    element: <ChatOperatorPage />,
  },
  {
    path: "/meeting",
    element: <MeetingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
